import React from 'react'
import { G1Nowifi } from '@e3dc-react/icons'
import { Box, SxProps, Theme, useTheme } from '@mui/material'

interface Props {
  sx?: SxProps<Theme>
}

/**
 * Offline icon in a circle indicating that some parts of a system are offline
 */
const OfflineIndicator: React.FC<Props> = ({ sx }) => {
  const theme = useTheme()
  return (
    <Box
      sx={{
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        height: 30,
        width: 30,
        borderRadius: '50%',
        backgroundColor: theme.palette.error.main,
        overflow: 'hidden',
        ...sx,
      }}
    >
      <G1Nowifi sx={{ color: 'white', width: '100%', height: '100%' }} />
    </Box>
  )
}

export default OfflineIndicator
